import { Theme } from '@emotion/react';

export const generateBreadcrumbsStyles = (theme: Theme) => ({
    wrapper: {
        marginTop: '16px',
        marginBottom: '24px',
        fontFamily: theme.palette.common.font,
        fontSize: '14px',
    },
    caret: {
        color: theme.palette.primary.main,
        display: 'inline-flex',
        margin: '0 6px',
        transform: 'scaleY(0.8) scaleX(0.5) scale(2)',
    },
});
